//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import aspectRatio from '~/constants/aspectRatio'
import headingMixin from '~/mixins/headingMixin'

export default {
  mixins: [headingMixin],

  props: {
    media: {
      type: Object,
      default: () => {}
    },

    aspectRatio: {
      type: String,
      default: '16:9',
      validator: value => aspectRatio.includes(value)
    },

    subtitle: {
      type: String,
      default: ''
    },

    copy: {
      type: Object,
      default: () => {}
    },

    copySize: {
      type: String,
      default: 'regular',
      validator: (value) => {
        return [
          'regular',
          'large'
        ].includes(value)
      }
    },

    cta: {
      type: Object,
      default: () => {}
    }
  },

  data () {
    return {
      hasHover: false
    }
  },

  computed: {
    hasMedia () {
      return this.media && !!this.media.src
    }
  },

  methods: {
    hasHoverOn () {
      this.hasHover = true
    },

    hasHoverOff () {
      this.hasHover = false
    }
  }
}
